import { useState, useEffect, useCallback, useRef } from 'react';

const PAGE_SIZE_SCROLL = 50;

export function usePagination(totalItems, filterKey) {
  const [visibleCount, setVisibleCount] = useState(50);
  const [isLoadingMore, setIsLoadingMore] = useState(false);
  const [showBackToTop, setShowBackToTop] = useState(false);

  const loadingRef = useRef(false);

  // Reset visible count when filters change
  const prevFilterKey = useRef('');
  if (filterKey !== prevFilterKey.current) {
    prevFilterKey.current = filterKey;
    if (visibleCount !== 50) setVisibleCount(50);
  }

  // Track scroll position for back-to-top button
  useEffect(() => {
    const onScroll = () => setShowBackToTop(window.scrollY > 400);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const loadMore = useCallback(() => {
    if (loadingRef.current) return;
    loadingRef.current = true;
    setIsLoadingMore(true);
    setTimeout(() => {
      setVisibleCount(prev => prev + PAGE_SIZE_SCROLL);
      setIsLoadingMore(false);
      loadingRef.current = false;
    }, 400);
  }, []);

  return {
    visibleCount,
    isLoadingMore,
    showBackToTop,
    loadMore,
  };
}
